import React, { useContext } from 'react';
import { Alert, Link, styled } from '@mui/material';
import { PageContext } from '@lib/contexts/pageContext';

const Anchor = styled('a')({
  cursor: 'auto',
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    color: 'inherit',
    textDecoration: 'none',
  }
});

const AlertAnchor = ({ ...props }) => (
  <Anchor href="#" className="alert-anchor" onClick={() => null} {...props} />
);

const Alerts = ({ modalContext = null }) => {
  let { pageMessages, pageErrorMessages } = useContext(PageContext);
  if (modalContext) {
    ({ pageMessages, pageErrorMessages } = modalContext);
  }
  const replaceSupportEmail = (str) => {
    if (!str || typeof str !== 'string' || !str.includes('<support email address>')) {
      return str;
    }
    const parts = str.split('<support email address>');
    return (
      <>
        {parts.map((s, i) => (
          <span key={`msg-${i}`}>
            <span>{s}</span>
            {(i < parts.length - 1) && (
              <Link href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</Link>
            )}
          </span>
        ))}
      </>
    );
  };

  return (
    <div className="alerts-container">
      {pageMessages && pageMessages.length > 0 && pageMessages.map((message, i) => (
        <AlertAnchor key={`message-${i}`}><Alert severity="success" sx={{ marginBottom: '10px' }}>{replaceSupportEmail(message)}</Alert></AlertAnchor>
      ))}
      {pageErrorMessages && pageErrorMessages.length > 0 && pageErrorMessages.map((message, i) => (
        <AlertAnchor key={`message-${i}`}><Alert severity="error" sx={{ marginBottom: '10px' }}>{replaceSupportEmail(message)}</Alert></AlertAnchor>
      ))}
    </div>
  )
};

export default Alerts;
